export enum RarityTypes {
  COMMON = 'COMMON',
  FANDOM = 'FANDOM',
  LEGENDARY = 'LEGENDARY',
  RARE = 'RARE',
  ULTIMATE = 'ULTIMATE',
  UNCOMMON = 'UNCOMMON',
}
